module.exports = __webpack_public_path__ + "assets/img/add.318e779c.png";